import React, { Component } from "react";

import { PRE_FLOP, FLOP, TURN_RIVER, GAME, DEALING } from '../constants/status'


class Buttons extends Component {
    constructor() {
        super()
        this.state = {
        }
    }

    bet = (x) => {

        const { setAction, solution, freezedButton } = this.props

        const style = (solution ? solution === x ? 'touched' : !freezedButton ? 'hidden' : '' : '')

        return (
            <div className="btn-item">
                <div className={`u-btn u-bet ${style}`} onClick={() => !solution && setAction(x)}>
                    <div className="u-btn-inner u-bet-inner">
                        <p>{x}x</p>
                        <span>BET</span>
                    </div>
                </div>
            </div>
        )

    }

    check = () => {

        const { setAction, solution, freezedButton } = this.props

        const style = (solution ? solution === 'check' ? 'touched' : !freezedButton ? 'hidden' : '' : '')

        return (
            <div className="btn-item">
                <div className={`u-btn u-check ${style}`} onClick={() => !solution && setAction('check')}>
                    <div className="u-btn-inner u-check-inner">
                        <p>&#10003;</p>
                        <span>CHECK</span>
                    </div>
                </div>
            </div>
        )

    }

    pass = () => {

        const { setAction, solution, freezedButton } = this.props

        const style = (solution ? solution === 'pass' ? 'touched' : !freezedButton ? 'hidden' : '' : '')

        return (
            <div className="btn-item">
                <div className={`u-btn u-pass ${style}`} onClick={() => !solution && setAction('pass')}>
                    <div className="u-btn-inner u-pass-inner">
                        <p>&#8213;</p>
                        <span>PASS</span>
                    </div>
                </div>
            </div>
        )

    }

    render = () => {

        const { status, solution, freezedButton, landscape } = this.props

        return (
            <div className={`ultimate-buttons ${landscape ? "landscape" : "pc"}`}>
                {(solution || status === GAME || status === DEALING || freezedButton) ? <div className="u-freezed-buttons" /> : null}
                {status === PRE_FLOP ? this.bet(4) : null}
                {status === PRE_FLOP ? this.bet(3) : null}
                {(status === FLOP) ? this.bet(2) : null}
                {(status === FLOP || status === TURN_RIVER) ? this.bet(1) : null}
                {status !== TURN_RIVER && status !== GAME && status !== DEALING ? this.check() : null}
                {(status == TURN_RIVER || status === GAME) ? this.pass() : null}
            </div>
        )
    }
}

export default Buttons

